export default "__VITE_PUBLIC_ASSET__8ce9b631__"